import { faGraduationCap, faInfo } from "@fortawesome/free-solid-svg-icons";
import IRouter from "../interfaces/IRouter";
import Exam from "../view/Private/Exam/Exam";
import StudentIndex from "../view/Private/Exam/StudentInfo/Student.index";
import FRSCInstructions from "../view/Private/Exam/FRSCInstructions/FRSCInstructions";
import ExamDashboard from "../view/Private/ExamDashboard/ExamDashboard";
import Instructions from "../view/Private/Instructions/Instructions.index";
import StartExam from "../view/Private/StartExam/StartExam.index";
import Profile from "../view/Private/Profile/Profile";
import Dashboard from "../view/Private/Dashboard/Dashboard";

export const examBaseUrl = "/exam";

const examRoutes:IRouter[] = [
    {
        path: "student-info",
        navbarShow: false,
        element: StudentIndex,
        name: "Student-Info",
        icon: faInfo
    },
    {
        path: "instructions-new",
        navbarShow: false,
        element: FRSCInstructions,
        name: "FRSC-Instructions",
        icon: faInfo
    },
    {
        path: "dashboard",
        navbarShow: false,
        element: Dashboard,
        name: "dashboard",
        icon: faInfo
    },
    {
        path: "instructions",
        navbarShow: false,
        element: Instructions,
        name: "Instructions",
        icon: faInfo
    },
    {
        path: "start",
        navbarShow: false,
        element: StartExam,
        name: "Start",
        icon: faInfo
    },
    {
        path: "exam-dashboard",
        navbarShow: false,
        element: ExamDashboard,
        name: "exam-dashboard",
        icon: faInfo
    },
    {
        path: "user/profile",
        navbarShow: false,
        element: Profile,
        name: "exam-dashboard",
        icon: faInfo
    },
]

export default examRoutes;